/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/visualization.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { ApiVisualization, GoogleRpcStatus } from '../models/index';
import {
  ApiVisualizationFromJSON,
  ApiVisualizationToJSON,
  GoogleRpcStatusFromJSON,
  GoogleRpcStatusToJSON,
} from '../models/index';

export interface CreateVisualizationRequest {
  namespace: string;
  visualization: ApiVisualization;
}

/**
 *
 */
export class VisualizationServiceApi extends runtime.BaseAPI {
  /**
   */
  async createVisualizationRaw(
    requestParameters: CreateVisualizationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiVisualization>> {
    if (requestParameters['namespace'] == null) {
      throw new runtime.RequiredError(
        'namespace',
        'Required parameter "namespace" was null or undefined when calling createVisualization().',
      );
    }

    if (requestParameters['visualization'] == null) {
      throw new runtime.RequiredError(
        'visualization',
        'Required parameter "visualization" was null or undefined when calling createVisualization().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/visualizations/{namespace}`;
    urlPath = urlPath.replace(
      `{${'namespace'}}`,
      encodeURIComponent(String(requestParameters['namespace'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ApiVisualizationToJSON(requestParameters['visualization']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiVisualizationFromJSON(jsonValue),
    );
  }

  /**
   */
  async createVisualization(
    namespace: string,
    visualization: ApiVisualization,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiVisualization> {
    const response = await this.createVisualizationRaw(
      { namespace: namespace, visualization: visualization },
      initOverrides,
    );
    return await response.value();
  }
}
